import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import { typography, spacing, components } from "../styles/designSystem";

const Hero = () => (
  <section
    id="hero"
    className="relative flex min-h-[100svh] items-center justify-center overflow-hidden px-0 pb-8 pt-24 text-white md:min-h-screen md:pb-0 md:pt-32"
  >
    {/* Background video */}
    <video
      className="absolute inset-0 w-full h-full object-cover"
      src="/videos/bg-video-hero.mp4"
      autoPlay
      muted
      loop
      playsInline
    />

    {/* Overlays */}
    <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/65 to-black/75" />

    {/* Decorative shapes */}
    <div className="animate-drift pointer-events-none absolute -right-20 top-[20%] h-64 w-64 rounded-full bg-primary/[0.15] blur-3xl" />
    <div className="animate-spin-slow pointer-events-none absolute right-[12%] bottom-[18%] h-16 w-16 rounded-full border border-white/15 border-dashed" />
    <div className="pointer-events-none absolute left-[15%] top-[28%] h-4 w-4 rounded-full bg-accent/50" />
    <div className="pointer-events-none absolute right-[20%] top-[15%] h-6 w-6 rounded-full border-[4px] border-primary/30" />

    {/* Content with staggered entrance */}
    <div
      className={`z-10 max-w-4xl mx-auto ${spacing.container} flex flex-col items-center justify-center gap-8 text-center`}
    >
      <div className="space-y-8">
        <p
          className={`${typography.label} text-white/70 animate-fade-up`}
          style={{ animationDelay: "0.2s" }}
        >
          Digital Studio for Small Businesses
        </p>

        <h1
          className={`${typography.heading.h1} text-white animate-fade-up`}
          style={{ animationDelay: "0.4s" }}
        >
          Your one-stop partner for
          <span className="block text-accent font-semibold">
            websites, apps &amp; marketing
          </span>
        </h1>

        <div
          className="flex justify-center animate-fade-up"
          style={{ animationDelay: "0.6s" }}
        >
          <div className="w-16 h-1 bg-gradient-to-r from-primary to-accent rounded-full" />
        </div>

        <p
          className={`${typography.body.large} text-white/80 max-w-2xl mx-auto animate-fade-up`}
          style={{ animationDelay: "0.7s" }}
        >
          Strategy, design, development and growth in one place. Simple process,
          clear pricing, tailored to small businesses that want to look
          professional without hiring a full in-house team.
        </p>
      </div>

      <div
        className="flex flex-col sm:flex-row gap-4 pt-6 animate-fade-up"
        style={{ animationDelay: "0.9s" }}
      >
        <Link
          to="/contact"
          className={`${components.button.primary} justify-center`}
        >
          Book a free consultation
          <FiArrowUpRight className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
        <Link
          to="/services"
          className="inline-flex justify-center items-center rounded-full border border-white/30 px-8 py-4 text-sm font-semibold text-white/90 hover:bg-white/10 hover:border-white/50 hover:-translate-y-0.5 transition-all duration-300"
        >
          View services
        </Link>
      </div>

      {/* Scroll hint */}
      <div
        className="relative mt-2 animate-fade-up md:absolute md:bottom-8 md:mt-0"
        style={{ animationDelay: "1.3s" }}
      >
        <div className="flex animate-bounce flex-col items-center gap-3">
          <span className={`${typography.label} text-white/50`}>
            Scroll to explore
          </span>

          <div className="h-8 w-px overflow-hidden bg-gradient-to-b from-white/60 to-white/10">
            <div className="h-8 w-px animate-pulse bg-white/40" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
